<template>
  <b-col cols="12" class="col-bordered offer-container">
    <b-row v-bind:class="{ 'bg-danger': offer.missingData }">
      <b-col cols="3" class="d-block d-sm-none"></b-col>
      <b-col cols="6" md="1" class="col-content col-content-image">
        <div class="image"><img :src="offer.image" /></div>
      </b-col>
      <b-col cols="12" md="1" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Variant</b-col>
          <b-col cols="7" md="12">{{ offer.variantKey }}</b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="2" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Brand</b-col>
          <b-col cols="7" md="12">{{ offer.brand }}</b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="2" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Model</b-col>
          <b-col cols="7" md="12">{{ offer.model }}</b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="1" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Item Id</b-col>
          <b-col cols="7" md="12">{{ offer.itemId }}</b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="3" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Variant</b-col>
          <b-col cols="7" md="12">
            <div class="reference-number" v-if="!offer.missingData">
              {{ offer.reference }} / {{ offer.condition }}, {{ offer.year }}
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="1" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Active</b-col>

          <b-col cols="7" md="12" v-if="isUpdatingActiveState">
            <b-spinner/>
          </b-col>
          <b-col cols="7" md="12" v-if="!isUpdatingActiveState">
            <button
              type="button"
              @click="toggleOfferActive()"
              class="btn btn-xs btn-active-offer btn-block"
              :class="{
                'btn-success': offer.active,
                'btn-secondary': !offer.active,
              }"
            >
              <span v-if="offer.active"><b-icon-check shift-h="-1"/></span>
              <span v-if="!offer.active"><b-icon-dash shift-h="-1"/></span>
            </button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="1" class="col-content" v-if="!offer.missingData">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Details</b-col>

          <b-col cols="7" md="12">
            <div @click="showModal = true" class="btn btn-xs btn-primary btn-active-offer">
              <b-icon-eye-fill shift-h="-1"/>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <watch-detail-modal @close="closeModal" v-if="showModal" :watch="offer" type="watch"></watch-detail-modal>
  </b-col>
</template>

<script>
import apiAuth from 'src/clients/apiAuth';
import constants from 'src/constants/constants';
import WatchDetailModal from 'Components/WatchDetailModal';

export default {
  name: 'AdminOfferRow',
  components: {
    WatchDetailModal,
  },
  props: ['offer'],
  data: function() {
    return {
      showModal: false,
      isUpdatingActiveState: false,
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    toggleOfferActive() {
      let options = {
        method: 'post',
        baseURL: constants.url.offerService.baseUrl,
        url: constants.url.offerService.api.setActiveState,
        data: {
          offerId: '' + this.offer.id,
          state: this.offer.active ? 0 : 1,
        },
      };

      this.isUpdatingActiveState = true;
      apiAuth(options)
        .then((response) => {
          console.log(response.data.offer);
          this.offer.active = response.data.offer.active;
          this.isUpdatingActiveState = false;
        })
        .catch((error) => {
          console.log(error);
          this.isUpdatingActiveState = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.offer-container {
  text-align: left;

  .brand,
  .model,
  .reference-number,
  .type,
  .year {
    display: inline-block;
    text-align: left;
  }

  .reference-number,
  .type,
  .year {
    color: #777777;
  }
}

.col-content {
  padding-top: 6px;
  padding-bottom: 4px;
}

.btn-xs {
  border-radius: 0.3rem;
  font-size: 0.8rem;
  padding: 2px 6px;
}

.image {
  img {
    width: auto;
    height: 1.8em;
    @media all and(max-device-width: 576px) {
      width: 100%;
      height: auto;
    }
  }
}

.btn-active-offer {
  font-size: 0.8rem;
  height: 27px;
  width: 27px;
}

.col-bordered {
  border: 1px solid #cccccc;
  border-top: none;
  &:hover,
  &:focus,
  &:active {
    background-color: #f1f1f1;
  }
}
</style>
